/**
 * Created by YJZX-LCH on 2017-08-24.
 */
export default {
  resize: function (doc, win) {
    var docEl = doc.documentElement,
      resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
      recalc = function () {
        var clientWidth = docEl.clientWidth;
        if (!clientWidth) return;
        // if (20 * (clientWidth / 320) > 25) {
        //   docEl.style.fontSize = 25 + 'px';
        // } else {
        docEl.style.fontSize = (clientWidth / 10) + 'px';
        // }
      };
    recalc();
    if (!doc.addEventListener) return;
    win.addEventListener(resizeEvt, recalc, false);
    doc.addEventListener('DOMContentLoaded', recalc, false);
  }
};



// WEBPACK FOOTER //
// ./src/components/base.js